import { AppThunk } from 'redux/store';
import { TypesPriceList } from './type';
import WebApi from 'core/services/WebApi';
import { getStoragePromoCodeApplication } from 'utils';
import { selectUserID } from 'redux/selectors';

export const getPriceList =
  (
    defaultProductId?: number,
    promo_code?: string | undefined,
    onSuccess?: (data: any) => void,
    onFailed?: (errors: any) => void
  ): AppThunk<void> =>
  (dispatch, getState) => {
    dispatch({ type: TypesPriceList.GET_PRICE_LIST_REQUEST });

    const state = getState();
    const userId = selectUserID(state);

    const promo_code = getStoragePromoCodeApplication();

    return WebApi.request({
      method: 'GET',
      url: `/api/products/${defaultProductId}/price_list?user_id=${userId}${
        promo_code ? `&promo_code=${promo_code}` : ''
      }`,
      onSuccess: (data) => {
        dispatch({
          type: TypesPriceList.GET_PRICE_LIST_SUCCESS,
          data: {
            priceList: data,
            promo_code,
          },
        });

        onSuccess && onSuccess(data);
      },
      onFailed: (errors) => {
        dispatch({ type: TypesPriceList.GET_PRICE_LIST_ERROR, errors });

        onFailed && onFailed(errors);
      },
      isAuth: true,
    });
  };
